import React from "react";

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  description?: string;
}

export function FormSection({
  title,
  children,
  className = "",
  description
}: FormSectionProps) {
  return (
    <div className={`border rounded-md p-6 bg-white ${className}`}>
      <div className="mb-4">
        <h2 className="text-xl font-semibold">{title}</h2>
        {description && (
          <p className="text-sm text-gray-500 mt-1">{description}</p>
        )}
      </div>
      {children}
    </div>
  );
}
